
    import Vue from "vue";
    import {Ripple} from "vuetify/lib/directives/";
    import {mapState} from "vuex";
    import RomaModalTop from "../commons/RomaModalTop.vue";
    import Validation from "../../validations";
    // Report
    import {PlanningReport} from '../../reports/PlanningReport';
    import {CoverageByCourseReport} from '../../reports/CoverageByCourseReport';
    import {SchoolCoverageReport} from '../../reports/SchoolCoverageReport';
    import {BaseReport} from '../../reports/BaseReport';
    import {IState} from "../../interfaces/IState";

    function requestDefaultValues() {
        return {
            unitPlan_id: null,
            plan_id: null,
            education_id: null,
            general: true,
            activities: true,
            cronogram: true,
            year: null
        };
    }

    export default Vue.extend({
        name: "RomaReportFiltersModal",
        props: {
            reportType: {
                type: String,
                required: false,
            },
            value: Boolean,
            unit: {
                type: Object,
                required: true,
            },
            maxWidth: {
                type: String,
                default: "55%"
            },
            overlayOpacity: {
                type: String,
                default: "0.8"
            },
            persistent: {
                type: Boolean,
                default: true
            },
            filterByEducation: {
                type: Boolean,
                default: false,
            },
            years: {
                type: Array,
            }
        },
        async created() {
            const response = await this.$store.dispatch('getEducations');
            if (response.data && response.data.status && response.data.status.code === 1) {
                this.educacionList = response.data.content;
            }
            if(this.years){
                this.request.year = [...this.years].pop();
            }
        },
        data() {
            return {
                educacionList: [],
                valid: false,
                loading: false,
                showing: this.value,
                request: requestDefaultValues(),
                rules: {
                    required: Validation.required
                }
            };
        },
        computed: {
            ...mapState(["user", "romaForFilters"]),
            validateCheckboxes() {
                return this.anySelected() || "Debe seleccionar al menos una opción";
            },
            multiplePlanUnits() {
                return this.unit === -1;
            },
            ...mapState({
                school(state: IState) {
                    return state.organizer.selectedSchool;
                },
            }),
        },
        watch: {
            unit(newValue) {
                if (!!newValue) {
                    this.request.unitPlan_id = newValue.id;
                    this.request.plan_id = newValue.id_plan;
                }
            },
            years(newValue) {
                if(newValue){
                    this.request.year = [...newValue].pop();
                }
            },
            value(newValue) {
                if(newValue && !this.filterByEducation){
                    this.request.general = true;
                    this.request.activities = true;
                    this.request.cronogram = true;
                }
                    
            }
        },
        methods: {
            async seeReport() {
                this.loading = true;
                const params = Object.entries(this.request)
                    .map(entry => `${entry[0]}=${(!entry[1] && entry[0].includes('_id')) ? -1 : !entry[1] ? false : entry[1]}`)
                    .join("&");

                const request = new URLSearchParams(params);
                request.append('reportType', this.reportType || 'PLANNING');

                let msj = {
                    show: true,
                    text: '',
                    color: 'red',
                };

                const response = await this.$store.dispatch('getReport', { params: request });

                if (!(response.data && response.data.status && response.data.status.code === 1)) {
                    msj.show = true;
                    if (response.data && response.data.status && response.data.status.code === 3) {
                        msj.text = response.data.content.message;
                        msj.color = "red";
                    } else {
                        msj.text = "No se pudo generar el reporte";
                        msj.color = "red";
                    }
                } else {
                    let report: BaseReport;
                    switch (this.reportType) {
                        case 'COURSE_COVERAGE':
                            report = new CoverageByCourseReport(this.user, this.school, {year: this.request.year, ...response.data.content}, this.$store.state.logoURL);
                            break;
                        case 'SCHOOL_COVERAGE':
                            report = new SchoolCoverageReport(this.user, this.school, response.data.content, this.$store.state.logoURL);
                            break;
                        default:
                            report = new PlanningReport(this.user, this.school, response.data.content, this.$store.state.logoURL);
                            break;
                    }
                    try {
                        msj.text = await report.downloadReport();
                        msj.color = 'success';
                    } catch (error) {
                        console.error("Error al generar reporte", error);
                        msj.text = error;
                    }
                    this.show(false);
                }
                this.$store.state.snackbar = msj;
                this.loading = false;
            },
            checkboxError() {
                if (this.request.cronogram === null || this.request.cronogram === undefined) {
                    this.request.cronogram = false;
                    if (this.request.general === null || this.request.general === undefined) this.request.general = false;
                    if (this.request.activities === null || this.request.activities === undefined) this.request.activities = false;
                }
            },
            anySelected(): boolean {
                return (
                    this.request.general ||
                    this.request.activities ||
                    this.request.cronogram
                );
            },
            show(value: Boolean) {
                this.$refs.filterForm.reset();
                if (!this.unit) this.request = Object.assign({}, requestDefaultValues());
                this.$emit("input", value);
            }
        },
        components: {
            RomaModalTop
        },
        directives: {
            Ripple
        }
    });
